import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=2684be3e&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=2684be3e&prod&lang=scss&scoped=true"
import style1 from "./Navbar.vue?vue&type=style&index=1&id=2684be3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2684be3e",
  null
  
)

export default component.exports